export const routes = [
  {
    path: '/sala-principal/:id/sala-indicadores-apuracao',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'sala.indicadores.apuracao.list',
    meta: {
      requiresAuth: true
    }
  }
]
